import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { memo } from 'react';
import { useGetDeviceWithAccessoriesUpdateSuggestions } from 'entities/device.service.accessories.upgrade/lib/check';
import { UpgradeAccessoriesSuggestion } from 'entities/device.service.accessories.upgrade/ui/notification';
export const UpdateDeviceAccessoriesFirmwareRequests = memo(function UpdateDeviceAccessoriesFirmwareRequests() {
    const update_suggestions = useGetDeviceWithAccessoriesUpdateSuggestions();
    if (update_suggestions.length === 0) {
        return null;
    }
    return (_jsx(_Fragment, { children: update_suggestions.slice(0, 3).map((suggestion, i) => (_jsx(UpgradeAccessoriesSuggestion, { suggestion: suggestion }, i))) }));
});
